import axios from "axios";
import { buildUrl } from "@/config";

export default {
  getDepartments() {
    const url = buildUrl("api/v1/department");
    console.log("Calling Departments API:", url);
    return axios.get(url);
  },
};
